import { API_DOMAIN } from "../../constants/api";
import axios from "../fetch/fetch";

export type OnTimeOverride = "PASS" | "FAIL";

const UPDATE_ASSIGNED_ON_TIME_OVERRIDE_API = `${API_DOMAIN}/assigned/on-time-override`;

export async function updateOnTimeOverrideAPI(params: {
    assignedId: string;
    onTimeOverride: OnTimeOverride | null;
    onTimeOverrideNote?: string;
}): Promise<any> {
    const response = await axios.put(UPDATE_ASSIGNED_ON_TIME_OVERRIDE_API, params);
    return response.data;
}

